var map = {
	"./asset_ui/src/load.js": 59011,
	"./communication_ui/src/load.js": 42139,
	"./file_ui/src/load.js": 23387,
	"./invoice_ui/src/load.js": 33588,
	"./ks_app/src/load.js": 69360,
	"./lms_ui/src/load.js": 97323,
	"./market_ui/src/load.js": 6113,
	"./marketing_ui/src/load.js": 21071,
	"./payment_ui/src/load.js": 83393,
	"./rms_ui/src/load.js": 31513,
	"./task_ui/src/load.js": 6624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96351;